import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'indent'
})
export class IndentPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return JSON.stringify(value, null, 2)
        .replace(/ /g, '&nbsp;')
        .replace('/\\n/g', '&lt;br/&gt;');
  }
}



// WEBPACK FOOTER //
// ./src/app/core/commons/utils/indent.pipe.ts